import * as brandColors from '../../../utils/brand-colors';

export default () => ({
  duration: {
    display: 'flex',
    salignItems: 'center',
  },
  timeContainer: { display: 'flex' },
  dueDateIcon: {
    marginRight: 4,
    fontSize: '18px',
    color: brandColors.danger.main,
  },
});
